import { OperationTypeEnum } from '@gtpl/shared-models/common-models';
import { ItemsDropDownResponseModel } from '@gtpl/shared-models/masters';
import { AssignBeheadingResponse, BeheadingDashboardResponse, BeheadingInventoryResponse, InProgressBeHeadingDto, InProgressBeheadingResponse, LotNumberInfoResponse, ProductionInventoryResponse } from '@gtpl/shared-models/production-management';
import { CommonResponse, SaleOrderDropDownResponseModel } from '@gtpl/shared-models/sale-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { BeHeadingService } from './be-heading.service';
import { LotInfoRequest } from './dto/lot-info.request';
import { OperationRequest } from './dto/operation-data.request';
import { ProductionInventoryData } from './dto/production-inventory.dto';
import { ProductionLogIdRequest } from './dto/production-log-id.request';
import { UnitRequest } from './dto/unit.id.request';
import { ProductionInventoryService } from './production-inventory.service';
import { ProductionLogService } from './production-log.service';
@ApiTags('Beheading')
@Controller('be-heading')
export class BeHeadingController {
    constructor(private beHeadingService: BeHeadingService,
        private logService: ProductionLogService,
        private inventoryService: ProductionInventoryService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/assignBeHeadingOperation')
    async assignBeHeadingOperation(@Body() inputReq: ProductionInventoryData): Promise<AssignBeheadingResponse> {
        try {
            return await this.beHeadingService.assignBeHeadingOperation(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssignBeheadingResponse, error);
        }
    }

    @Post('/getWorkstationWiseInprogressData')
    async getWorkstationWiseInprogressData(@Body() req: OperationRequest): Promise<InProgressBeheadingResponse> {
        try {
            return await this.logService.getWorkstationWiseInprogressData(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(InProgressBeheadingResponse, error);
        }
    }
    @Post('/getBeheadingInventoryData')
    async getBeheadingInventoryData(@Body() req: OperationRequest): Promise<BeheadingInventoryResponse> {
        try {
            return await this.logService.getBeheadingInventoryData(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BeheadingInventoryResponse, error);
        }
    }

    @Post('/getAllBeheadingInfo')
    async getAllBeheadingInfo(@Body() req: UnitRequest): Promise<BeheadingDashboardResponse> {
        try {
            return await this.logService.getAllBeheadingInfo(req.unitId, OperationTypeEnum.BE_HEADING)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BeheadingDashboardResponse, error);
        }
    }

    /**
     * 
     * @param req 
     * @returns all in progress jobs
     */
    @Post('/getAllBeheadingInProgressJobs')
    async getAllBeheadingInProgressJobs(@Body() req: UnitRequest): Promise<InProgressBeheadingResponse> {
        try {
            return await this.logService.getAllBeheadingInProgressJobs(req.unitId, OperationTypeEnum.BE_HEADING)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(InProgressBeheadingResponse, error);
        }
    }


    @Post('/getAllBeheadingExternalPlantJobs')
    async getAllBeheadingExternalPlantJobs(@Body() req: UnitRequest): Promise<InProgressBeheadingResponse> {
        try {
            return await this.logService.getAllBeheadingExternalPlantJobs(req.unitId, OperationTypeEnum.BE_HEADING)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(InProgressBeheadingResponse, error);
        }
    }

    @Post('/updateBeheadingJobCompleted')
    async updateBeheadingJobCompleted(@Body() req: ProductionLogIdRequest): Promise<CommonResponse> {
        try {
            return await this.logService.updateBeheadingJobCompleted(req.productionLogId,undefined,undefined,req.opBoxes,req.outputQuantity);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllBeheadingPlantJobs')
    async getAllBeheadingPlantJobs(@Body() req: UnitRequest): Promise<InProgressBeheadingResponse> {
        try {
            return await this.logService.getAllBeheadingPlantJobs(req.unitId, OperationTypeEnum.BE_HEADING)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(InProgressBeheadingResponse, error);
        }
    }

    @Post('/getBeheadingInventoryInfo')
    async getBeheadingInventoryInfo(@Body() req: UnitRequest): Promise<ProductionInventoryResponse> {
        try {
            return await this.inventoryService.getInventoryInfo(OperationTypeEnum.BE_HEADING, req.unitId)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ProductionInventoryResponse, error);
        }
    }

    @Post('/getLotNumberInfo')
    async getLotNumberInfo(@Body() lotNoReq: LotInfoRequest): Promise<LotNumberInfoResponse> {
        try {
            return await this.inventoryService.getLotNumberInfoForBeheading(lotNoReq)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(LotNumberInfoResponse, error);
        }
    }


    @Post('/getSaleOrdersForLot')
    async getSaleOrdersForLot(@Body() lotNoReq: LotInfoRequest): Promise<SaleOrderDropDownResponseModel> {
        try {
            return await this.inventoryService.getSaleOrdersForLot(lotNoReq)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
        }
    }


    @Post('/getSaleOrderItemsForLotAndSo')
    async getSaleOrderItemsForLotAndSo(@Body() lotNoReq: LotInfoRequest): Promise<ItemsDropDownResponseModel> {
        try {
            return await this.inventoryService.getSaleOrderItemsForLotAndSo(lotNoReq)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ItemsDropDownResponseModel, error);
        }
    }

  
}
